module.exports = __webpack_public_path__ + "img/sunset-4.c048ca08.jpeg";